import { makeShowTAddFamillyLinkLogic } from './helpers';
export var showLogic = makeShowTAddFamillyLinkLogic({});
